import useLenis from "@/hooks/useLenis";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import ProblemReframe from "@/components/ProblemReframe";
import PipelineArchitecture from "@/components/PipelineArchitecture";
import LayerTimeline from "@/components/LayerTimeline";
import Systems from "@/components/Systems";
import Paradigm from "@/components/Paradigm";
import WhatYouGet from "@/components/WhatYouGet";
import Differentiation from "@/components/Differentiation";
import FAQ from "@/components/FAQ";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

export default function Landing() {
  useLenis();

  return (
    <main className="bg-[#050505] text-white min-h-screen relative" data-testid="landing-page">
      <Navbar />
      <Hero />
      <PipelineArchitecture />
      <ProblemReframe />
      <LayerTimeline />
      <Systems />
      <Paradigm />
      <WhatYouGet />
      <Differentiation />
      <FAQ />
      <CTASection />
      <Footer />
    </main>
  );
}
